import header from '../components/header/header.js'
import { SwitchCanadaUS } from '../components/footer/footer.js'
import { startHero } from '../components/hero/hero.js'
import { tools } from '../components/tools/tools.js'
import { revealLinksOnAction, setTimezone } from "../../_modules/helpers";
import { handleRefsUs } from '@studybay/common-client-library/ref-handle';
import { FirstTouchTracking } from '@studybay/common-client-library/first-touch-tracking';

header()
SwitchCanadaUS()
startHero()
tools()
revealLinksOnAction(() => {
    handleRefsUs()
    FirstTouchTracking()
})
setTimezone()